import { createApp } from 'vue'
import { MotionPlugin } from '@vueuse/motion'
import vuetify from '~/lms/plugins/vuetify'
import LmsIndexPage from '~/lms/pages/LmsIndexPage.vue'
import '~/lms/styles/lms-tokens.scss'
import '~/lms/styles/lms-vue-host.scss'
import '~/lms/styles/lms-rails-chrome.scss'

function readBoot () {
  const el = document.getElementById('lms-index-boot')
  if (!el) return null
  try {
    return JSON.parse(el.textContent)
  } catch (e) {
    console.error('[lms_index] failed to parse boot JSON', e)
    return null
  }
}

function mount () {
  const el = document.getElementById('lms-index-app')
  if (!el) return
  const boot = readBoot()
  if (!boot) {
    el.innerHTML = '<p style="padding:24px;color:#5b6b76">Unable to load list configuration.</p>'
    return
  }
  const app = createApp(LmsIndexPage, { boot })
  app.use(vuetify)
  app.use(MotionPlugin)
  app.mount(el)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount)
} else {
  mount()
}
